'use strict';

import controller from './documentacion-proyecto.controller';
import template from './documentacion-proyecto.html';
import service  from '../../integracion-siga/integracion.service';

const DocumentacionProyectoComponent = {
  bindings:{},
  controller,
  template,
  service
};

export default DocumentacionProyectoComponent;



// WEBPACK FOOTER //
// ./src/app/components/empresas/documentacion-proyecto/documentacion-proyecto.component.js